export const CONTEXT_MENU_MAP = {
  isBoardShareable: '공유하기',
  isBoardUpdatable: '수정하기',
  isUccUpdatable: '수정하기',
  isViewLater: '나중에 보기',
  isBoardDeletable: '삭제하기',
  isReasonDeletable: '삭제하기',
  isUccDeletable: '삭제하기',
  isBlindDeletable: '삭제하기',
  isClipReasonDeletable: '삭제하기',
  isCatchReasonDeletable: '삭제하기',
  isMovable: '게시판 이동',
  isVodMovableToBoard: '게시판 노출',
  isPinFixable: '홈에 고정하기',
  isPinCancelable: '고정 해제',
  isVodPinFixable: '홈에 고정하기',
  isVodPinCancelable: '고정 해제',
  isNoticeCancelable: '공지 해제',
  isReportable: '신고하기',
  isUccEditable: '편집하기',
  isUccMidRollSettable: '중간광고 설정',
  isUccPlaylistAddable: '재생목록에 담기',
  isUccChapterSettable: '챕터설정',
  isStoryReasonDeletable: '삭제하기',
  // 재생목록 관련
  isPlaylistDeletable: '삭제하기',
  isPlaylistEmbedDeletable: '삭제하기',
  isPlaylistEmbeddable: '재생목록 퍼가기',
  isPlaylistShareable: '공유하기',
  isPlaylistUpdatable: '수정하기',
  // 댓글 관련
  isCommentDeletable: '삭제하기',
  isCommentPinCancelable: '고정 해제',
  isCommentPinFixable: '고정하기',
  isCommentReportable: '신고하기',
  isCommentUpdatable: '수정하기',
  isCommentHidden: '댓글 숨기기',
  isCommentCancelHidden: '댓글 숨기기 해제',

  //답글 관련
  isReplyDeletable: '삭제하기',
  isReplyReportable: '신고하기',
  isReplyUpdatable: '수정하기',
  isReplyHidden: '답글 숨기기',
  isReplyCancelHidden: '답글 숨기기 해제',

  // 방명록 관련
  isGuestBookDeletable: '삭제하기',
  isGuestBookUpdatable: '수정하기',

  // 방명록 댓글 관련
  isGuestMemoDeletable: '삭제하기',
  isGuestMemoUpdatable: '수정하기',
} as const;

export type CONTEXT_MENU_TITLE =
  (typeof CONTEXT_MENU_MAP)[keyof typeof CONTEXT_MENU_MAP];

export const POST_AUTHORITY_KEY = {
  isBoardShareable: 'isBoardShareable',
  isUccDeletable: 'isUccDeletable',
  isBoardUpdatable: 'isBoardUpdatable',
  isUccUpdatable: 'isUccUpdatable',
  isBoardDeletable: 'isBoardDeletable',
  isReasonDeletable: 'isReasonDeletable',
  isMovable: 'isMovable',
  isPinable: 'isPinable',
  isPinFixable: 'isPinFixable',
  isPinCancelable: 'isPinCancelable',
  isVodPinFixable: 'isVodPinFixable',
  isVodPinCancelable: 'isVodPinCancelable',
  isNoticeCancelable: 'isNoticeCancelable',
  isCommentWritable: 'isCommentWritable',
  isReplyWritable: 'isReplyWritable',
  isReportable: 'isReportable',
  isUccEditable: 'isUccEditable',
  isUccMidRollSettable: 'isUccMidRollSettable',

  // 안드로이드 블라인드 관련
  isBlindReportable: 'isBlindReportable',
  isViewLater: 'isViewLater',
} as const;

export const VOD_AUTHORITY_KEY = {
  isBoardShareable: 'isBoardShareable',
  isReasonDeletable: 'isReasonDeletable',
  isBlindDeletable: 'isBlindDeletable',
  isClipReasonDeletable: 'isClipReasonDeletable',
  isCatchReasonDeletable: 'isCatchReasonDeletable',
  isUccDeletable: 'isUccDeletable',
  isUccUpdatable: 'isUccUpdatable',
  isVodPinable: 'isVodPinable',
  isVodPinFixable: 'isVodPinFixable',
  isVodPinCancelable: 'isVodPinCancelable',
  isUccEditable: 'isUccEditable',
  isUccMidRollSettable: 'isUccMidRollSettable',
  isUccPlaylistAddable: 'isUccPlaylistAddable',
  isUccChapterSettable: 'isUccChapterSettable',
  isStoryReasonDeletable: 'isStoryReasonDeletable',
  isVodMovableToBoard: 'isVodMovableToBoard',
  // 재생목록 관련
  isPlaylistDeletable: 'isPlaylistDeletable',
  isPlaylistEmbedDeletable: 'isPlaylistEmbedDeletable',
  isPlaylistEmbeddable: 'isPlaylistEmbeddable',
  isPlaylistShareable: 'isPlaylistShareable',
  isPlaylistUpdatable: 'isPlaylistUpdatable',
} as const;

export const COMMENT_AUTHORITY_KEY = {
  isCommentDeletable: 'isCommentDeletable',
  isCommentPinCancelable: 'isCommentPinCancelable',
  isCommentPinFixable: 'isCommentPinFixable',
  isCommentReportable: 'isCommentReportable',
  isCommentUpdatable: 'isCommentUpdatable',
  isCommentHidden: 'isCommentHidden',
  isCommentCancelHidden: 'isCommentCancelHidden',
};

export const REPLY_AUTHORITY_KEY = {
  isReplyDeletable: 'isReplyDeletable',
  isReplyReportable: 'isReplyReportable',
  isReplyUpdatable: 'isReplyUpdatable',
  isReplyHidden: 'isReplyHidden',
  isReplyCancelHidden: 'isReplyCancelHidden',
};

export const GUEST_AUTHORITY_KEY = {
  isGuestBookDeletable: 'isGuestBookDeletable',
  isGuestBookUpdatable: 'isGuestBookUpdatable',
};

export const GUEST_REPLY_AUTHORITY_KEY = {
  isGuestMemoDeletable: 'isGuestMemoDeletable',
  isGuestMemoUpdatable: 'isGuestMemoUpdatable',
};

export const BROADCAST_TYPE = {
  GUEST: 101,
  SCHEDULE: 102,
  PHOTO: 103,
  NORMAL: 104,
  UCC: 105,
  UCC_LIST: 115,
  LINE: 106,
  TITLE: 107,
  REVIEW: 108,
  HIGHLIGHT: 109,
  EDITOR: 105,
  PARENT_COMMENT: 203,
  LIKE: 205,
  CHILD_COMMENT: 204,
  REPORT: 206,
} as const;

export const UCC_FILE_TYPE = {
  NORMAL: 'NORMAL',
  REVIEW: 'REVIEW',
  HIGHLIGHT: 'HIGHLIGHT',
  EDITOR: 'EDITOR',
  CLIP: 'CLIP',
  CATCH: 'CATCH',
  ALL: 'ALL',
  CATCHSTORY: 'CATCHSTORY',
} as const;

export type BroadcastKey =
  | 'GUEST'
  | 'SCHEDULE'
  | 'PHOTO'
  | 'NORMAL'
  | 'UCC'
  | 'UCC_LIST'
  | 'LINE'
  | 'TITLE'
  | 'REVIEW'
  | 'HIGHLIGHT'
  | 'EDITOR'
  | 'PARENT_COMMENT'
  | 'LIKE'
  | 'CHILD_COMMENT'
  | 'REPORT';

export const LIST_ORDER_BY = {
  REG_DATE: 'reg_date',
  REG_DATE_ASC: 'reg_date_asc',
  READ_CNT: 'read_cnt',
  COMMENT_CNT: 'comment_cnt',
  LIKE_CNT: 'like_cnt',
  LIVE_PV: 'live_pv',
  VOD_ADD_DATE: 'vod_add_date',
  POPULAR: 'popular',
  GIFT_CNT: 'gift_cnt',
} as const;

export const VOD_THUMBNAIL_STATUS = {
  AUTH_DENIED: 'AUTH_DENIED',
  EXPIRE: 'EXPIRE',
  ENCODING_FAIL: 'ENCODING_FAIL',
  UPLOAD_FAIL: 'UPLOAD_FAIL',
  DELETE: 'DELETE',
  LOADING: 'LOADING',
  ADULT_LOCK: 'ADULT_LOCK',
  LOCK: 'LOCK',
  BLIND: 'BLIND',
  ADULT: 'ADULT',
  SUCCEED: 'SUCCEED',
} as const;

export const AUTH_NO_TYPES = {
  READ_ALL: '101',
  PRIVATE: '102',
  READ_FAVORITE: '103',
  READ_FANCLUB: '104',
  READ_MANAGER: '106',
  READ_SUBSCRIPTION: '107',
} as const;

export const VOD_ROUTE_TYPES = {
  /** 전체 */
  ALL: 'all',
  /** 다시보기 */
  REVIEW: 'review',
  /** 클립 */
  CLIP: 'clip',
  /** 업로드 VOD */
  NORMAL: 'normal',
  /** 재생목록 */
  LIST: 'list',
} as const;

export const CATCH_ROUTE_TYPES = {
  /** 캐치 */
  CATCH: 'catch',
  /** 캐치 스토리 */
  STORY: 'catchstory',
} as const;

export const KAKAO_SHARE_TEMPLATE_ID_VOD = 103712;
export const KAKAO_SHARE_TEMPLATE_ID_POST = 113265;

export const VOD_CREATED_BY_TYPES = {
  ALL: 'all',
  STREAMER: 'streamer',
  USER: 'user',
} as const;

/** 성인 전용 카테고리에 대응하는 코드값 */
export const ADULT_CATEGORY = Number('00030000');
